import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Avatar — аватар пользователя/группы (FR-USERS-03). Показывает изображение src; при отсутствии или
// ошибке загрузки — fallback-инициалы на детерминированном цветном фоне. Опц. точка присутствия.
// Презентационный: данные через props. Цвет фолбэка детерминирован по colorKey (обычно userId) —
// тот же алгоритм senderColorKey, что и для имени автора в группе (стабильность цвета по человеку).
import { useState } from 'react';
import { initialsOf } from '../util/format.js';
import { senderColorKey } from '../tokens/index.js';
export function Avatar({ name, src, size = 40, online, colorKey, style, }) {
    // Локальное UI-состояние: упала ли загрузка картинки → переключаемся на инициалы.
    const [broken, setBroken] = useState(false);
    const showImage = Boolean(src) && !broken;
    const bg = senderColorKey(colorKey ?? name);
    const wrap = {
        position: 'relative',
        display: 'inline-flex',
        width: `${size}px`,
        height: `${size}px`,
        flex: '0 0 auto',
        ...style,
    };
    const circle = {
        width: '100%',
        height: '100%',
        borderRadius: 'var(--radius-avatar)',
        objectFit: 'cover',
        display: 'block',
    };
    const fallback = {
        ...circle,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: bg,
        color: 'var(--color-text-inverse)',
        fontSize: `${Math.round(size * 0.4)}px`,
        fontWeight: 'var(--weight-semibold)',
        userSelect: 'none',
    };
    const dot = {
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: `${Math.max(8, Math.round(size * 0.26))}px`,
        height: `${Math.max(8, Math.round(size * 0.26))}px`,
        borderRadius: '50%',
        background: 'var(--color-online)',
        border: '2px solid var(--color-bg)',
        boxSizing: 'border-box',
    };
    return (_jsxs("span", { "data-avatar": "", style: wrap, children: [showImage ? (_jsx("img", { src: src, alt: name, style: circle, "data-avatar-image": "", onError: () => setBroken(true) })) : (_jsx("span", { "aria-label": name, role: "img", "data-avatar-fallback": "", style: fallback, children: initialsOf(name) })), online ? _jsx("span", { "data-avatar-online": "", "aria-hidden": "true", style: dot }) : null] }));
}
//# sourceMappingURL=Avatar.js.map